import { map, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataService, ApiService, InspectionPluginService } from '../../shared/services/index';
import { InspectionPlugin } from '../../shared/models/index';
import { PeripheralInfoFactoryPluginService } from './peripheralinfo-plugin-factory.service';

@Injectable()
export class PeripheralInfoPluginService extends InspectionPluginService {
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private peripheralFactory: PeripheralInfoFactoryPluginService
  ) {
    super(apiService, dataService, null, peripheralFactory);
  }

  public updatePeripheralInfo(inspectionId: string, pluginId: string, peripheralInfos: any): Observable<any> {
    return this._update(inspectionId, pluginId, peripheralInfos).pipe(
      map((res: InspectionPlugin) => {
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private _update(inspectionId: string, pluginId: string, peripheralInfos: any): Observable<InspectionPlugin> {
    return this.peripheralFactory.updatePeripheralInfo(inspectionId, pluginId, peripheralInfos, 'PeripheralInfos').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
